"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/ArrowUp.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ArrowUp = function ArrowUp(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 179.3 94.93"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Up Arrow Icon"), _react2.default.createElement("path", {
    className: "arrow-up",
    d: "M94.75 1.28l83.2 85.9a4.53 4.53 0 1 1-6.4 6.4l-79.9-82.7-83.9 82.7a4.47 4.47 0 0 1-6.4 0 4.47 4.47 0 0 1 0-6.4l87-85.9a4.65 4.65 0 0 1 6.4 0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = ArrowUp;